(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__countdownAnnouncementInitialized) return;
    window.__countdownAnnouncementInitialized = true;

    function updateTimer(el) {
      const endDate = new Date(el.dataset.end).getTime();

      if (isNaN(endDate)) return;

      const diff = endDate - Date.now();

      if (diff <= 0) {
        const block = el.closest('[data-countdown-block]');
        const message = block?.querySelector('[data-countdown-expired-message]');

        if (message) {
          const expiredContent = message.innerHTML;

          // Reemplaza completamente el anuncio y el contador
          block.innerHTML = expiredContent;
        } else {
          block.innerHTML = '¡Oferta finalizada!';
        }

        return false;
      }

      const showDays = el.dataset.showDays === 'true';

      const totalSeconds = Math.floor(diff / 1000);

      const days = Math.floor(totalSeconds / 86400);

      const hours = showDays
        ? Math.floor((totalSeconds % 86400) / 3600)
        : Math.floor(totalSeconds / 3600);

      const minutes = Math.floor((totalSeconds % 3600) / 60);

      const seconds = totalSeconds % 60;

      const pad = (n) => String(n).padStart(2, '0');

      const set = (selector, value) => {
        const node = el.querySelector(selector);

        if (node) {
          node.textContent = value;
        }
      };

      // Solo actualizamos los días si están habilitados
      if (showDays) {
        set('[data-countdown-days]', pad(days));
      }

      set('[data-countdown-hours]', pad(hours));
      set('[data-countdown-minutes]', pad(minutes));
      set('[data-countdown-seconds]', pad(seconds));

      return true;
    }

    function tick() {
      document
        .querySelectorAll('[data-countdown-timer]')
        .forEach((el) => {
          if (el.dataset.expired === 'true') return;

          const alive = updateTimer(el);

          if (alive === false) {
            el.dataset.expired = 'true';
          }
        });
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
